import get from 'lodash/get'
import { mapGetters, mapActions } from 'vuex'

export const tabs = {
	mounted () {
		this.goToSelected()
	},
	watch : {
		$route (to, from) {
			this.goTo(get(to, 'params.selectedTab'))
		},
	},
	computed : {
		...mapGetters('tabs', [ 'settingsTab', 'settingsTabs' ]),
		allTabs () {
			return this.$store.getters[`tabs/${this.pageSlug}Tabs`]
		},
		currentTab () {
			return this.$store.getters[`tabs/${this.pageSlug}Tab`]
		},
		selectedTab () {
			return this.$get('$route.params.selectedTab')
		},
	},
	methods : {
		...mapActions('tabs', [ 'goTab' ]),
		navTo (tab) {
			this.goTab({ page: this.pageSlug, tab, strict: true })
		},
		goTo (tab) {
			this.goTab({ page: this.pageSlug, tab })
		},
		goToSelected () {
			if (this.selectedTab) {
				this.goTo(this.selectedTab)
			}
		},
	},
}
